"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Parse = require("parse/node");
class AssociatedPayment extends Parse.Object {
    constructor(attributes) {
        super('AssociatedPayment', attributes);
    }
    /** the status of this payment */
    get status() { return this.get('status'); }
    set status(value) { this.set('status', value); }
    /** the code to be used when the retailer is being created */
    get start() { return this.get('start'); }
    set start(value) { this.set('start', value); }
    /** the code to be used when the retailer is being created */
    get end() { return this.get('end'); }
    set end(value) { this.set('end', value); }
    /** the user that owns this association */
    get commissionsDetails() { return this.get('commissionsDetails'); }
    set commissionsDetails(value) { this.set('commissionsDetails', value); }
    /** the associated that owns this association */
    get associated() { return this.get('associated'); }
    set associated(value) { this.set('associated', value); }
    /** the percentage of the omnichat fee that will be paid to the associated */
    get totalCommissionsEarned() { return this.get('totalCommissionsEarned'); }
    set totalCommissionsEarned(value) { this.set('totalCommissionsEarned', value); }
}
exports.AssociatedPayment = AssociatedPayment;
Parse.Object.registerSubclass('AssociatedPayment', AssociatedPayment);
//# sourceMappingURL=AssociatedPayment.js.map